module.exports = __webpack_public_path__ + "static/media/11.3a41ee04.mp3";